module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.6-248.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.5.6.md
// module id = 691
// module chunks = 272